import React from 'react';

// Basic subscription card - adjust fields once actual API response confirmed
const SubscriptionCard = ({ subscription }) => {
  const { id, status, nextBillingDate, createdAt, interval, intervalCount, lineItems } =
    subscription;

  return (
    <div className="subscription-card">
      <h4>Subscription #{id}</h4>
      <p>
        Status: <strong>{status}</strong>
      </p>
      {nextBillingDate && <p>Next Billing: {new Date(nextBillingDate).toLocaleDateString()}</p>}
      {createdAt && <p>Started: {new Date(createdAt).toLocaleDateString()}</p>}
      {(interval || intervalCount) && (
        <p>
          Interval: {intervalCount || 1} {interval}
        </p>
      )}
      {lineItems && lineItems.length > 0 && (
        <ul className="subscription-items">
          {lineItems.slice(0, 3).map(item => (
            <li key={item.id}>
              {item.title} x {item.quantity}
            </li>
          ))}
          {lineItems.length > 3 && <li>and {lineItems.length - 3} more...</li>}
        </ul>
      )}
    </div>
  );
};

export default SubscriptionCard;
